import { AutoClose } from 'components/shared/AutoClose';
import React from 'react';
import { closeWindow } from 'utils/closeWindow';

const Digilocker: React.FC = () => {

    return (
        <AutoClose
            delayInSeconds={3}
            runner={closeWindow}
            message="You can now close this window & continue with your kyc"
        />
    );
};

export default Digilocker;  